'use client';
import { typeAboutTurnCom } from '../types/TypesDocsId';
import { useQueryClient } from '@tanstack/react-query';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks';
// import { apiGetRequest } from '@/hook/R_query/useFetch';
import Content_Roting from '../../admission/layout/Content_Roting';
import FormTurnModal from '../../admission/FormTurnModal';
import FormLoginModal from '../../admission/FormLoginModal';
import {
    setFormModal,
    setSelectedTurn,
} from '@/lib/RTK/features/AdmissionSlice';
import { useCallback, useEffect, useState } from 'react';
import { DialogHeader } from '@/components/ui/dialog';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogDescription,
} from '@/components/ui/dialog';
import parse from 'html-react-parser';
import { rulesDataModal } from '@/constant';
import { GoAlertFill } from 'react-icons/go';
import { useRouter } from 'next/navigation';
import { formatNameDoctor } from '@/constant/scripts';
import { Button } from '@/components/ui/button';
import { GiBackwardTime } from 'react-icons/gi';
import TurnPreviewSkeleton from './turn-preview-skeleton';
// import TurnPreviewSkeleton from './turn-preview-skeleton';

const TurnPreview = (props: typeAboutTurnCom) => {
    const {
        id,
        idDoctor,
        // turnSatus,
        nameDoc,
        data,
        firstDateTimes,
    } = props;

    const psistionModal = useAppSelector((state) => state.admission.position);
    const dispatch = useAppDispatch();
    const [enableSubmit, setSubmitEnable] = useState(false);
    const [showRules, setShowRules] = useState(false);
    const [accept, setAccept] = useState(false);
    const [acceptSubmit, setAcceptSubmit] = useState(false);
    const [resetContent, setResetContent] = useState(false);

    const router = useRouter();

    const { token, register, mobile } = useAppSelector(
        (state) => state.auth_token_slice,
    );
    const queryClient = useQueryClient();
    const prevTurn:
        | {
              time: string;
              doctor_name: string;
              date: string;
              gdate: string;
              doctor_id: string;
              office: string;
          }
        | undefined = queryClient.getQueryData([
        'check-reserve',
        mobile,
        token,
    ]);

    function handleResetPosition() {
        dispatch(setFormModal(''));
        setResetContent(true);
    }
    const selectedTurn = useAppSelector((s) => s.admission.currentTurnTimeDate);

    const timeTurnfirst = {
        first_date: String(data?.first_date),
        first_time: String(data?.time),
    };
    const updateModalPage = useCallback(() => {
        if (!token || token === 'undefined') {
            setTimeout(() => {
                dispatch(setFormModal('formlogin'));
            }, 20);
        } else {
            if (register === '1') {
                dispatch(setFormModal('formturn'));
                dispatch(
                    setSelectedTurn({
                        date:
                            selectedTurn?.date ||
                            timeTurnfirst?.first_date ||
                            '',
                        time:
                            selectedTurn?.time ||
                            timeTurnfirst?.first_time ||
                            '',
                        jalali: selectedTurn?.jalali || '',
                        childId: '0',
                    }),
                );
            } else {
                router.push(
                    `/doctor/${idDoctor}/${formatNameDoctor(
                        nameDoc,
                    )}/${id}/turn`,
                );
            }
        }
    }, [
        dispatch,
        id,
        idDoctor,
        nameDoc,
        register,
        router,
        selectedTurn?.date,
        selectedTurn?.jalali,
        selectedTurn?.time,
        timeTurnfirst?.first_date,
        timeTurnfirst?.first_time,
        token,
    ]);

    useEffect(() => {
        if (enableSubmit) {
            setShowRules(true);
        }
    }, [enableSubmit]);

    return (
        <div className="relative">
            {data?.all_am_turns && data?.months ? (
                <Content_Roting
                    setSubmitEnable={setSubmitEnable}
                    timeTurnfirst={timeTurnfirst}
                    doctor={{
                        docid: idDoctor,
                        clinic: String(id),
                    }}
                    setResetContent={setResetContent}
                    resetContent={resetContent}
                    allTurns={data?.all_am_turns}
                    dates={data?.months}
                    matab_plus_id={0}
                    firstDateTimes={firstDateTimes}
                />
            ) : (
                <TurnPreviewSkeleton />
            )}

            <Dialog
                open={showRules}
                onOpenChange={(isOpen: boolean) => {
                    setShowRules(isOpen);

                    if (!isOpen) {
                        dispatch(setFormModal(''));
                        setAcceptSubmit(false);
                        setAccept(false);
                        setSubmitEnable(false);
                        setResetContent(true);
                    }
                }}
            >
                <DialogContent className="smp:!max-w-[500px] !flex !flex-col !gap-0 max-w-full max-h-full md:!h-min !px-4 overflow-y-hidden overflow-x-hidden !bg-white md:!rounded-3xl h-full md:!max-h-[95%] sm:!overflow-hidden">
                    <DialogHeader className="hidden !py-0">
                        <DialogTitle className="text-center sm:!text-base text-sm"></DialogTitle>
                        <DialogDescription></DialogDescription>
                    </DialogHeader>

                    {acceptSubmit && prevTurn?.time ? (
                        <div className="text-center pb-8">
                            <div className="bg-blue-shaded p-2 w-max mx-auto rounded-2xl flex justify-center items-center">
                                <GiBackwardTime className="text-blue text-2xl" />
                            </div>
                            <p className="font-semibold pt-4">
                                یک نوبت برای دکتر {prevTurn?.doctor_name} در
                                تاریخ {prevTurn?.date} ، <br /> ساعت{' '}
                                {prevTurn?.time + ' '} از قبل برای شما رزرو شده
                                است.
                            </p>
                            <p className="pt-1">
                                آیا مایل به ثبت نوبت جدید هستید ؟
                            </p>
                        </div>
                    ) : (
                        <>
                            <div className="mb-4 mt-2 bg-blue-shaded sm:!pt-4 sm:!pb-0 pt-2 rounded-2xl">
                                <div className="relative sm:!px-6 px-2 mb-1 overflow-hidden transition-[max-height] duration-500 ease-in-out max-h-[1000px] pb-3">
                                    <div className="flex gap-1 items-center my-5 font-bold">
                                        <p className="text-[17px] flex items-center gap-2 text-red-600">
                                            <GoAlertFill className="i_f" />
                                            توجه
                                        </p>
                                        <p className="text-[15px] pt-0.5 leading-normal">
                                            کاربر گرامی:
                                        </p>
                                    </div>

                                    <fieldset className="mb-[15px] pb-3 flex items-center gap-5 font-semibold">
                                        <ul className="list-disc mr-4 flex_col gap-3">
                                            {rulesDataModal(
                                                nameDoc || 'نام',
                                                data?.per_visit &&
                                                    data.per_visit.trim()
                                                        .length > 0
                                                    ? parse(data.per_visit)
                                                    : undefined,
                                                data?.coordination || 'دارد',
                                                false,
                                            ).map(
                                                (i) =>
                                                    i && (
                                                        <li
                                                            key={i?.id}
                                                            className={`text-sm ${
                                                                i?.active
                                                                    ? 'text-red-700'
                                                                    : ''
                                                            }`}
                                                        >
                                                            {i?.label}
                                                        </li>
                                                    ),
                                            )}
                                        </ul>
                                    </fieldset>
                                </div>
                            </div>

                            <div className="flex justify-between gap-y-2 smp:!flex-row flex-col-reverse items-start">
                                <fieldset
                                    className="flex gap-2 smp:!pr-5 pb-5 w-fit items-center select-none font-bold"
                                    onClick={() => setAccept(!accept)}
                                >
                                    <input
                                        type="checkbox"
                                        className="w-4 h-4 accent-blue"
                                        checked={accept}
                                        onChange={() => {}}
                                    />
                                    تایید می کنم
                                </fieldset>
                                {selectedTurn ? (
                                    <div className="flex justify-between smp:!w-max w-full items-center gap-1.5">
                                        <p className="font-regular whitespace-nowrap text-[#222222]">
                                            زمان نوبت:
                                        </p>
                                        <div className="flex gap-2 smp:!w-max w-full items-center flex-wrap font-medium text-[#222222] text-sm">
                                            <p>
                                                تاریخ :{' '}
                                                {selectedTurn?.jalali ||
                                                    'زمانی ثبت نشده است'}
                                            </p>
                                            <p>ساعت : {selectedTurn?.time}</p>
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </>
                    )}

                    <div className="flex gap-2">
                        {acceptSubmit && prevTurn?.time ? (
                            <Button
                                variant={'primaryShaded'}
                                className="!py-2 !px-6 bg-blue-shaded hover:!bg-blue-shaded text-blue !rounded-2xl w-full"
                                onClick={() => {
                                    setSubmitEnable(false);
                                    setShowRules(false);
                                    setAccept(false);
                                    dispatch(
                                        setSelectedTurn({
                                            date: prevTurn?.gdate || '',
                                            time: prevTurn?.time || '',
                                            jalali: prevTurn?.date || '',
                                            childId: '',
                                        }),
                                    );
                                    router.push(
                                        `/doctor/${
                                            prevTurn?.doctor_id
                                        }/${formatNameDoctor(
                                            prevTurn?.doctor_name,
                                        )}/${
                                            prevTurn?.office
                                        }/continue/checkout`,
                                    );
                                }}
                            >
                                تکمیل نوبت قبل
                            </Button>
                        ) : (
                            <Button
                                variant={'blueShaded'}
                                className="!py-2 !px-6 !rounded-2xl w-full"
                                onClick={() => {
                                    setSubmitEnable(false);
                                    setShowRules(false);
                                    setAccept(false);
                                    setAcceptSubmit(false);
                                    setResetContent(true);
                                }}
                            >
                                انصراف
                            </Button>
                        )}

                        <Button
                            variant={'blue'}
                            disabled={!accept}
                            className="!py-2 !px-6 !rounded-2xl w-full"
                            onClick={() => {
                                if (!prevTurn?.time) {
                                    updateModalPage();
                                    setShowRules(false);
                                    setSubmitEnable(false);
                                    setAccept(false);
                                }
                                if (acceptSubmit) {
                                    updateModalPage();
                                    setShowRules(false);
                                    setSubmitEnable(false);
                                    setAccept(false);
                                } else {
                                    setAcceptSubmit(true);
                                }
                            }}
                        >
                            ادامه
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>

            {/* {isPending ? <TurnPreviewSkeleton /> : ''} */}
            {psistionModal === 'formlogin' && (
                <FormLoginModal
                    endFunction={() => {
                        setShowRules(false);
                        setSubmitEnable(false);
                        setAcceptSubmit(false);
                        setAccept(false);
                        setResetContent(true);
                    }}
                    docname={nameDoc}
                    handleResetPosition={handleResetPosition}
                    enableSubmit={enableSubmit}
                    buttonElement={<p></p>}
                    clinic={id}
                    docid={idDoctor}
                    isTurn
                />
            )}

            {psistionModal === 'formturn' && (
                <FormTurnModal
                    ids={{
                        clinicid: String(id),
                        docid: idDoctor,
                    }}
                    docname={nameDoc}
                    clinic={id}
                    docid={idDoctor}
                    buttonElement={<p></p>}
                    timeTurnfirst={timeTurnfirst}
                    handleResetPosition={handleResetPosition}
                    enableSubmit={enableSubmit}
                />
            )}
        </div>
    );
};

export default TurnPreview;
